import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
// import { TourProvider } from '@reactour/tour';
// import { Step } from './Types/Step';
import { AxiosInterceptor } from './Authentication/AxiosInterceptor';

import { Provider } from 'react-redux';
import { store } from './Redux/Store/Store';
import ToastPortal from './Components/Utils/ToastPortal/ToastPortal';
import LoadingWrapper from './Components/Utils/Loading/LoadingWrapper';
import { IsIncludedInTestClient } from './API/ClientInfo/ClientInfo';

// const steps: Step[] = [
//   {
//     selector: '.nav-item-evaluate',
//     content: 'Step 1 – Open up Evaluate'
//   },
//   {
//     selector: '#tour-new-activity',
//     content: 'Step 2 - Click "New activity" button to create a new diagnostic'
//   },
//   {
//     selector: '#????',
//     content: 'Step 3 – Select testing template called "Innovate Test"'
//   },
//   {
//     selector: '#????',
//     content: 'Step 4 – Answer the questions'
//   },
//   {
//     selector: '#????',
//     content: 'Step 5 – Ask Mia to summarise your text by clicking on "Generate Assessment"'
//   },
// ]

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0Provider
        domain="mesma.eu.auth0.com"
        clientId="6cEckUpj4BeV1Ck4cffeThPI5fZuiLCO"
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: 'https://api.mesma.co.uk'
        }}
      >
        <Provider store={store}>
          <AxiosInterceptor>
            {/* <TourProvider steps={steps}> */}
            <ToastPortal />
                <App />
            {/* </TourProvider> */}
          </AxiosInterceptor>
        </Provider>
      </Auth0Provider>
    </BrowserRouter>
  </React.StrictMode>
);